import ActionType from '@actions/type';

const _store = {
  percent: 0,
  received: 0,
  total: 0,
  releaseNotes: '',
  loopDelay: 1000 * 60,
  isStartDownload: false,
  show: false,
  forceUpdate: true,
  version: '',
  newVersion: '',
  ignoreVersion: '',
  fullpath: '',
  downloadUrl: '',
  showBubble: null,
  webVersion: '3.16.0',
  showWebUpgradeNotice: false,
};

function checkVersion(newVersion, oldVersion) {
  if (process.env.NODE_ENV === 'staging') return false;
  const a1 = newVersion.split('.');
  const a2 = oldVersion.split('.');
  for (let i = 0; i < a1.length; i++) {
    if (+a1[i] > +a2[i]) {
      return true;
    }
  }
  return false;
}

export default function upgrade(state = _store, action) {
  switch (action.type) {
    case ActionType.INIT_VERSION:
      return {
        ...state,
        version: action.version,
        ignoreVersion: action.ignoreVersion || state.ignoreVersion,
      };
    case ActionType.CHECK_UPGRADE_SUCCESS: {
      const webRelease = action.data.web_release || {};
      const clientRelease = action.data;
      let webVersionUpdate = false;
      if (state.webVersion) {
        webVersionUpdate = webRelease.release_notes && checkVersion(webRelease.version, state.webVersion);
      }
      return {
        ...state,
        releaseNotes: clientRelease.release_notes,
        forceUpdate: clientRelease.force_update,
        newVersion: clientRelease.version,
        downloadUrl: clientRelease.dl_link,
        loopDelay: (clientRelease.check_rate > 60 ? clientRelease.check_rate : 60) * 1000,
        show: !state.show ? clientRelease.version > state.version
        && (clientRelease.version !== state.ignoreVersion) : true,
        showBubble: state.showBubble === null ? state.version < clientRelease.version
        : state.showBubble,
        webVersion: state.webVersion === null ? webRelease.version : state.webVersion,
        webReleaseNotes: webRelease.release_notes,
        webVersionUpdate, // 作为后面判断是否显示通知的依据
        showWebUpgradeNotice: webRelease.version !== state.webVersion && webVersionUpdate,
      };
    }
    case ActionType.IGNORE_UPGRADE:
      return {
        ...state,
        ignoreVersion: action.version,
        show: false,
      };
    case ActionType.SHOW_UPGRADE_DIALOG:
      return {
        ...state,
        show: true,
      };
    case ActionType.START_DOWNLOAD:
      return {
        ...state,
        isStartDownload: true,
      };
    case ActionType.UPGRADE_DOWNLOADING:
      return {
        ...state,
        percent: action.percent,
        received: action.received,
        total: action.total,
        fullpath: action.fullpath,
      };
    case ActionType.CLOSE_UPGRADE_BUBBLE:
      return {
        ...state,
        showBubble: false,
      };
    case ActionType.JUMP_TO:
      if (action.prevRouter.path !== action.router.path
        && action.router.path.split('/').length === 1
        && state.webVersionUpdate) {
        return {
          ...state,
          showWebUpgradeNotice: true,
        };
      }
      return state;
    case ActionType.HIDE_WEB_UPGRADE_NOTICE:
      return {
        ...state,
        showWebUpgradeNotice: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/upgrade.js